module.exports = __webpack_public_path__ + "static/media/add-file-icon.3e13c7d4.svg";